import { MerchantState } from './types'

export const merchantState: MerchantState = {
  guid: ''
}
